import { render } from "./MainNavbar.vue?vue&type=template&id=236681f5&scoped=true&ts=true"
import script from "./MainNavbar.vue?vue&type=script&lang=ts"
export * from "./MainNavbar.vue?vue&type=script&lang=ts"

import "./MainNavbar.vue?vue&type=style&index=0&id=236681f5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236681f5"]])

export default __exports__